@for (item of copmanyAddressForm.controls; track item; let i = $index) {
  <pr-input-map
    (placeChanged)="toValue = $event"
    placeholder="Enter to address..."
    label="Saisissez l’adresse de du siège social de l'entreprise"
    [formGroup]="item"
    [isGMaps]="true"
    [countries]="countries"
    [derrors]="derrors"
    [isDefault]="false"
  >
  </pr-input-map>
}

<pr-button-add
  type="button"
  display="neutral"
  (click)="addFields()"
  label="Ajouter une résidence fiscale"
  rightIcon="+"
>
</pr-button-add>
